// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DayType;
(function (DayType) {
    DayType[DayType["NOT_WORKING"] = 0] = "NOT_WORKING";
    DayType[DayType["SHORTED"] = 1] = "SHORTED";
    DayType[DayType["WORKING"] = 2] = "WORKING";
})(DayType || (DayType = {}));
